import { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";
import "./css/PaymentChartToggle.css";

const PaymentChartWithYear = ({ monthlyDataByYear, yearlyData }) => {
  const years = Object.keys(monthlyDataByYear);
  const [view, setView] = useState("monthly");
  const [selectedYear, setSelectedYear] = useState(years[years.length - 1]);

  const chartData =
    view === "monthly"
      ? monthlyDataByYear[selectedYear]
      : yearlyData;


      const barColor = view === "monthly" ? "#2563eb" : "#16a34a";
    const activeBarColor = view === "monthly" ? "#16a34a" : "#2563eb" ;

  const xKey = view === "monthly" ? "month" : "year";

  return (
    <div className="chart-card">
      <div className="chart-header">
        <h3>Maintenance Collection</h3>

        <div className="controls">
          {view === "monthly" && (
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="year-select"
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          )}

          <div className="toggle">
            <button
              className={view === "monthly" ? "active" : ""}
              onClick={() => setView("monthly")}
            >
              Monthly
            </button>
            {1 == 2 && <button
              className={view === "yearly" ? "active" : ""}
              onClick={() => setView("yearly")}
            >
              Yearly
            </button> }
          </div>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="amount" fill = {barColor} radius={[6, 6, 0, 0]} activeBar={{fill:activeBarColor}} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PaymentChartWithYear;